import React from "react";
import { useNavigate } from "react-router-dom";
import { path } from "../../utils/common/constant";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import Detail from "../Tiptap/Detail";
import { convertToSlug } from "../../utils/common/slugConverter";
import { encryptString } from "../../utils/common/hashData";

const CardBlog = ({
  creator_avatar,
  creator,
  title,
  content,
  thumbnail,
  category,
  id,
  subtitle,
}) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const removeImages = (content) => {
    while (true) {
      // Tìm chỉ số bắt đầu và kết thúc của thẻ <img>
      let startIndex = content.indexOf("<img");
      let endIndex = content.indexOf(`draggable="true">`, startIndex);

      // Nếu không còn <img>, thoát khỏi vòng lặp
      if (startIndex === -1 || endIndex === -1) break;

      // Loại bỏ thẻ <img> và kiểm tra <p> bao quanh
      content = content.slice(0, startIndex) + content.slice(endIndex + 17);

      // Kiểm tra nếu <p> bao quanh <img> và loại bỏ nó
      let pStartIndex = content.indexOf('<p style="text-align: center">');
      let pEndIndex = content.indexOf("</p>", pStartIndex);

      if (pStartIndex !== -1 && pEndIndex !== -1 && pStartIndex < startIndex) {
        content = content.slice(0, pStartIndex) + content.slice(pEndIndex + 4);
      }
    }
    return content;
  };

  const slug = convertToSlug(title);

  return (
    <div
      className="cardcustome cursor-pointer  ease-linear"
      onClick={() => {
        // navigate("../" + path.common.BLOGDETAIL.replace(":id", id), {
        //   state: {
        //     id,
        //   },
        // });
        navigate(
          "../" +
            path.common.BLOGDETAIL.replace(
              ":id",
              encryptString({
                str: id.toString(),
                secretKey: process.env.PRIVATE_KEY,
              })
            ),
          {
            state: {
              id: encryptString({
                str: id.toString(),
                secretKey: process.env.PRIVATE_KEY,
              }),
            },
          }
        );
      }}
    >
      <div className=" overflow-hidden cursor-pointer rounded-[17px]   ">
        <img
          className="object-cover w-full h-[250px] qhd:h-[300px]  hover:scale-125  duration-300 ease-linear "
          src={thumbnail}
        ></img>
      </div>

      <div className="flex gap-4  mt-[30px] mb-[18px]">
        <div className="">
          <img
            className=" h-[50px] w-[50px]  object-cover rounded-full"
            src={creator_avatar}
          ></img>
        </div>
        <div className=" flex  flex-col gap-1">
          <p
            className=" text-primary text-[1rem] qhd:text-[1rem]"
            style={{ fontWeight: 400 }}
          >
            {category}
          </p>
          <p
            className=" text-primary text-[1rem] qhd:text-[1rem]"
            style={{ fontWeight: 400 }}
          >
            {creator}
          </p>
        </div>
      </div>

      <div className="flex justify-start items-center qhd:pb-[10px] ">
        <p className=" text-primary line-clamp-1  text-[1.5rem] qhd:text-[1.5rem] ">
          {title}
        </p>
      </div>
      <div className="flex items-start min-h-[100px] ">
        <p
          className=" line-clamp-3 text-primary text-[1rem]  qhd:text-[1rem] pt-[0.5rem] mb-[1rem] text-justify"
          style={{ fontWeight: 100, lineHeight: 1.6 }}
        >
          {(subtitle ?? "") ? subtitle : parse(removeImages(content))}
        </p>
      </div>
      <div
        className="flex justify-start py-2"
        onClick={() => {
          navigate("../" + path.common.BLOGDETAIL, {
            state: {
              id,
            },
          });
        }}
      >
        <p
          className="underline text-primary text-[1rem]  qhd:text-[1rem]"
          style={{ fontWeight: 600 }}
        >
          {t("ReadAll")}
        </p>
      </div>
    </div>
  );
};

export default CardBlog;
